// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

var PublicSuffixList = require('psl');
var domainObject = PublicSuffixList.parse(document.domain);
// {
//     "input": "www.iporto.io",
//     "tld": "io",
//     "sld": "iporto",
//     "domain": "iporto.io",
//     "subdomain": "www",
//     "listed": true
// }

export const environment = {
  production: true,
  app_name: 'iPORTO',

  // PRD
  web_url: 'https://iporto.com.br',
  app_url: 'https://app.iporto.com.br',
  api_url: 'https://api.iporto.com.br/api/',
  api_doc: 'https://api.iporto.com.br/docs',
  api_url_auth: 'https://api.iporto.com.br/api/',
  api_url_account: 'https://api.iporto.com.br/api/',
  // Spelt — autenticacao (SSO) e painel do cliente.
  // O token chega como ?spelt_token= e e trocado por sessao neste endpoint.
  spelt_panel_url: 'https://app.iporto.com.br',
  sso_exchange_url: 'https://api.iporto.com.br/public/sso/spelt/exchange',


  cookie_domain: '.iporto.com.br',

  services: {
    marketing: 'http://marketing.iporto.com.br',
  },

  http_garbage_collection: null,

  marketplace: {
    hostname: domainObject.domain,
    domainObject: domainObject,
  },

  page: {
    url: document.URL,
    domain: document.domain,
    expression: document.location.pathname,
  },
};
